import { useEffect } from 'react';
// From the file itself, not the search index: the site chunks stay small
import { presetSearchAge } from '../user/search/searchPersistence';

/**
 * The search's age range a mature page starts a guest on: 40 to the age
 * slider's top (`SearchForm`, `max={99}`, sent as `maxAge=99`).
 */
export const MATURE_SEARCH_AGE: [number, number] = [40, 99];

/**
 * A mature topic page (`/mature`, `/rijpe-vrouwen`, `/reife-frauen`): saves
 * {@link MATURE_SEARCH_AGE} as the search's age range unless the visitor
 * already has one, so `/search` after signup opens on older profiles.
 */
export const useMatureSearchAge = (): void => {
  useEffect(() => {
    presetSearchAge(MATURE_SEARCH_AGE);
  }, []);
};
